import React, { createContext, useContext, useState, useEffect } from "react";
import {
  getAnnouncements,
  getAnnouncement,
  reorderAnnouncements,
  getHPAnnouncements,
} from "./utils";
import {
  getAgencies,
  getPriorities,
  getRoadways,
  getStates,
  getAnnouncementLogs,
  getEvents,
  getAdminWebFiles,
  getLinks,
} from "./utils";

// Create the context
const AnnouncementsContext = createContext();

// Create a provider component
export const AnnouncementsProvider = ({ children }) => {
  const [reload, setReload] = useState(true);
  const [pageLoading, setPageLoading] = useState(true);
  const [announcements, setAnnouncements] = useState(null);
  const [highPriorityAnnouncements, setHighPriorityAnnouncements] =
    useState(null);
  const [announcement, setAnnouncement] = useState();
  const [selectedAnnoucement, setSelectedAnnouncement] = useState(null);
  const [selectedAnnoucementLog, setSelectedAnnouncementLog] = useState(null);
  const [selectedAnnoucementLogs, setSlectedAnnouncementLogs] = useState(null);
  const [viewAllLogs, setViewAllLogs] = useState(false);
  const [events, setEvents] = useState(null);
  const [selectedEventBtn, setSelectedEventBtn] = useState(false);
  const [adminWebFiles, setAdminWebFiles] = useState(null);
  const [openAdminWebFilesPage, setOpenAdminWebFilesPage] = useState(null);
  const [links, setLinks] = useState(null);
  const [selectedLinkBtn, setSelectedLinkBtn] = useState(false);
  const [agencies, setAgencies] = useState(null);
  const [roadways, setRoadways] = useState(null);
  const [states, setStates] = useState(null);
  const [states2, setStates2] = useState(null);
  const [authenticationChecked, setAuthenticationChecked] = useState("Success");

  const [filters, setFilters] = useState({
    state: "all",
    agency: "all",
    priority: "all",
    roadway: "all",
    type: "all",
    includeExpired: true,
    highPriority: false,
  });

  const [filterValues, setFilterValues] = useState({
    states: [],
    agencies: [],
    priorities: [],
    roadways: [],
    type: [
      "highPriority",
      "construction",
      "newsItem",
      "siteNews",
      "transit",
      "weather",
    ],
    includeExpired: filters.includeExpired,
  });

  useEffect(() => {
    if (selectedAnnoucement != null && selectedAnnoucement.id !== null) {
      getAnnouncement(selectedAnnoucement.id, setAnnouncement);
      getAgencies(setAgencies);
    }
  }, [selectedAnnoucement]);

  useEffect(() => {
    getStates((data) => setFilterValues((prev) => ({ ...prev, states: data })));
    getAgencies((data) =>
      setFilterValues((prev) => ({ ...prev, agencies: data })),
    );
    getPriorities((data) =>
      setFilterValues((prev) => ({ ...prev, priorities: data })),
    );
    getRoadways((data) =>
      setFilterValues((prev) => ({ ...prev, roadways: data })),
    );
    getAdminWebFiles(setAdminWebFiles);
    getLinks(setLinks);
    getAgencies(setAgencies);
    getEvents(setEvents);
  }, []);

  useEffect(() => {
    if (reload) {
      getAgencies((data) =>
        setFilterValues((prev) => ({ ...prev, agencies: data })),
      );
      getRoadways((data) =>
        setFilterValues((prev) => ({ ...prev, roadways: data })),
      );
    }
  }, [reload]);

  useEffect(() => {
    if (filters.highPriority) {
      getAnnouncements(
        filters.state,
        filters.agency,
        filters.priority,
        filters.roadway,
        filters.type,
        filters.includeExpired,
        (announcementData) => {
          if (announcementData && announcementData.length > 0) {
            let allAnnounceIds = announcementData.map(
              (announcement) => announcement.id,
            );
            reorderAnnouncements(
              allAnnounceIds,
              announcementData,
              setAnnouncements,
            );
          } else {
            setAnnouncements(announcementData);
          }
        },
        setPageLoading,
        setAuthenticationChecked,
      );
    } else {
      getAnnouncements(
        filters.state,
        filters.agency,
        filters.priority,
        filters.roadway,
        filters.type,
        filters.includeExpired,
        setAnnouncements,
        setPageLoading,
        setAuthenticationChecked,
      );
    }

    getHPAnnouncements(
      filters.state,
      filters.agency,
      filters.priority,
      filters.roadway,
      filters.type,
      filters.includeExpired,
      setHighPriorityAnnouncements,
      setPageLoading,
      setAuthenticationChecked,
    );
  }, [
    filters.state,
    filters.agency,
    filters.priority,
    filters.roadway,
    filters.type,
    filters.includeExpired,
    filters.highPriority,
  ]);

  useEffect(() => {
    if (reload) {
      getAnnouncements(
        filters.state,
        filters.agency,
        filters.priority,
        filters.roadway,
        filters.type,
        filters.includeExpired,
        setAnnouncements,
        setPageLoading,
        setAuthenticationChecked,
      );
      getHPAnnouncements(
        filters.state,
        filters.agency,
        filters.priority,
        filters.roadway,
        filters.type,
        filters.includeExpired,
        setHighPriorityAnnouncements,
        setPageLoading,
        setAuthenticationChecked,
      );
      setReload(false);
    }
  }, [reload, filters]);

  useEffect(() => {
    if (null === selectedAnnoucementLog) {
      setSlectedAnnouncementLogs(null);
    } else {
      getAnnouncementLogs(
        selectedAnnoucementLog.id,
        setSlectedAnnouncementLogs,
      );
    }
  }, [selectedAnnoucementLog]);

  return (
    <AnnouncementsContext.Provider
      value={{
        announcement,
        announcements,
        highPriorityAnnouncements,
        filters,
        selectedAnnoucement,
        selectedAnnoucementLog,
        filterValues,
        selectedAnnoucementLogs,
        events,
        adminWebFiles,
        links,
        pageLoading,
        agencies,
        roadways,
        states,
        states2,
        setStates2,
        setStates,
        setRoadways,
        setAgencies,
        setSelectedAnnouncementLog,
        setSlectedAnnouncementLogs,
        setSelectedAnnouncement,
        setFilters,
        setAnnouncements,
        setHighPriorityAnnouncements,
        setAnnouncement,
        setEvents,
        setReload,
        selectedEventBtn,
        setSelectedEventBtn,
        setAdminWebFiles,
        openAdminWebFilesPage,
        setOpenAdminWebFilesPage,
        setLinks,
        selectedLinkBtn,
        setSelectedLinkBtn,
        setPageLoading,
        authenticationChecked,
        setAuthenticationChecked,
        viewAllLogs,
        setViewAllLogs,
      }}
    >
      {children}
    </AnnouncementsContext.Provider>
  );
};

// Custom hook to use the AnnouncementsContext
export const useAnnouncements = () => {
  const context = useContext(AnnouncementsContext);
  if (!context) {
    throw new Error(
      "useAnnouncements must be used within an AnnouncementsProvider",
    );
  }
  return context;
};
